export const GET_ALL_SCHEDULES = 'GET_ALL_SCHEDULES ';
export const CREATE_SCHEDULES = 'CREATE_SCHEDULES';
export const UPDATE_SCHEDULES = 'UPDATE_SCHEDULES';
export const DELETE_SCHEDULES =  'DELETE_SCHEDULES ';